<!-- 停车审批-->
<template>
  <div class="wrapper">
    <div class="navCard">
      <a
        v-for="(item, index) in tabs"
        :key="index"
        :class="[activeTab == index ? 'active' : '']"
        @click="changeTab(index)"
        >{{ item.title }}<span v-if="activeTab == index"></span
      ></a>
    </div>
    <div class="mainCard">
      <div class="mainBox">
        <!--基本信息  -->
        <div class="card">
          <div class="cardTitle">
            <h3>基本信息</h3>
            <span>{{
              myDataObj.approStatus | itemFilter('approve_status', allSelect)
            }}</span>
          </div>
          <p>
            <label>审批类型</label>
            <span>{{ myDataObj.groupName }}</span>
          </p>
          <p>
            <label>发起人</label>
            <span>{{ myDataObj.promoterName }}</span>
          </p>
          <p>
            <label>发起时间</label>
            <span>{{ myDataObj.promoterTime }}</span>
          </p>
          <p>
            <label>审批时长</label>
            <span>{{ myDataObj.diff | timeFilter }}</span>
          </p>
        </div>

        <!--审批内容  -->
        <div class="card">
          <div class="cardTitle">
            <h3>审批内容</h3>
          </div>
          <div class="cardMain">
            <p>
              <label>车主姓名</label>
              <span>{{
                myDataObj.businessData.userName
                  ? myDataObj.businessData.userName
                  : ''
              }}</span>
            </p>
            <p>
              <label>联系电话</label>
              <span>{{ myDataObj.businessData.phone }}</span>
            </p>
            <p v-if="myDataObj.businessData.companyName">
              <label>公司名称</label>
              <span>{{ myDataObj.businessData.companyName }}</span>
            </p>
            <p>
              <label>项目名称</label>
              <span>{{ myDataObj.businessData.subProjectName }}</span>
            </p>
            <p>
              <label>车场名称</label>
              <span>{{ myDataObj.businessData.parkName }}</span>
            </p>
            <div class="box">
              <p>
                <label>生效日期</label>
                <span>{{ myDataObj.businessData.applyStartDay }}</span>
              </p>
              <p>
                <label>截止日期</label>
                <span>{{ myDataObj.businessData.applyEndDay }}</span>
              </p>
            </div>
          </div>
        </div>

        <!--车牌信息  -->
        <div class="card">
          <div class="cardTitle">
            <h3>车牌信息</h3>
            <!-- <a>查看合同<img src="@/assets/img/titleRight.png" alt=""></a> -->
          </div>
          <div
            class="cardMain"
            v-for="(item, index) in myDataObj.businessData.prkParkLotPlateBeans"
          >
            <p class="p">
              <label>车牌号</label>
              <span class="tags_wrap"
                >{{ item.plateNo }}
                <span
                  class="tags"
                  v-if="
                    myDataObj.bizFlag == 'TC_PARKYZCP' &&
                      myDataObj.bsid == item.id
                  "
                  >新</span
                >
                <span
                  class="tags"
                  v-if="
                    myDataObj.bizFlag == 'TC_PARKYZXQ' &&
                      myDataObj.bsid == item.id
                  "
                  >续</span
                >
              </span>
            </p>
            <p>
              <label>申请日期</label>
              <span>{{ item.applyAt }}</span>
            </p>
            <p>
              <label>车辆图片</label>
              <span class="spanBox">
                <img
                  class="spanBox_img"
                  :src="itemFile.path"
                  alt=""
                  v-for="(itemFile, indexFile) in item.fileList"
                  @click="viewImage(index, indexFile)"
                />
              </span>
            </p>
            <!-- <p>
              <label>车牌号</label>
              <span>{{contractDetail.traceUserName}}</span>
            </p> -->
          </div>
        </div>

        <!--审批附件  -->
        <!-- <div class="card" v-if="approveFileArr.length !== 0&&common.sence==1">
        <div class="cardTitle">
          <h3>审批附件</h3>
        </div>
        <div class="appendixCard">
          <div v-for="(item,index) in approveFileArr"  @click="fileRouter(item)">
            <span>{{item.displayName}}</span>
            <span>查看附件<img src="@/assets/img/rightIcon.png" alt=""></span>
          </div>
          <div v-for="(item,index) in approveFileArr">
            <span>{{item.displayName}}</span>
            <span>查看附件<img src="@/assets/img/rightIcon.png" alt=""  @click="showFilepage(item)"></span>
          </div>
        </div>
      </div> -->

        <!--审批附件  -->
        <!-- <div class="card" v-else>
        <div class="cardTitle">
          <h3>审批附件</h3>
        </div>
        <div class="appendixCard">
          <div v-for="(item,index) in approveFileArr" @click="fileRouter(item)">
            <span>{{item.displayName}}</span>
            <span>查看附件<img src="@/assets/img/rightIcon.png" alt=""></span>
          </div>
          <a :href="item.path" v-for="(item,index) in approveFileArr">
            <span>{{item.displayName}}</span>
            <span>查看附件<img src="@/assets/img/rightIcon.png" alt=""></span>
          </a>
        </div>
      </div> -->
        <approvalProgress :myDataObj="myDataObj"></approvalProgress>
      </div>
    </div>
    <footer v-if="edit">
      <a @click="showShadow = 2">不通过</a>
      <a @click="showShadow = 1">审批通过</a>
    </footer>
    <div v-if="showShadow" class="shadowCard">
      <div class="shadowBox">
        <h3>审批原因</h3>
        <textarea placeholder="请输入说明信息" v-model="markContent"></textarea>
        <div class="btnCard">
          <a @click="showShadow = false">取消</a>
          <a @click="doInstance(showShadow)">确认</a>
        </div>
      </div>
    </div>

    <!-- 查看大图 -->
    <fade-animation>
      <common-gallary
        :imgs="arrImgs"
        :curIndex="curIndex"
        v-show="showGallary"
        @close="showGallary = false"
      ></common-gallary>
    </fade-animation>
  </div>
</template>

<script>
import mixin from './approvalMixin' // 引入mixin文件
import CommonGallary from '../../components/Gallary'
import FadeAnimation from '../../components/FadeAnimation'
import BScroll from 'better-scroll'

import storage from './../../utils/storage'
import approvalProgress from '@/components/approvalProgress'
import wx from 'weixin-js-sdk'
import {
  loadOneInnstance,
  queryContractApproveAttachmentList,
  serversHttp,

  doInstance,
  queryAttachmentListByOneData,
} from '@/utils/api'

import { mapGetters } from 'vuex'
var scroll

export default {
  name: 'App',
  mixins: [mixin],
  data() {
    return {
      // tabs: [
      //   {
      //     title: '基本信息'
      //   },
      //   {
      //     title: '审批内容'
      //   },
      //   {
      //     title: '审批流程'
      //   }
      // ],
      // activeTab: 0,
      // myDataObj: {
      //   businessData: {}
      // },
      self_fee_code: {},
      contractDetailData: {
        bsContractHeaderVo: {}
      },
      contractDetail: {},
      // edit: false,
      // showShadow: false,
      // markContent: '',
      // companyId: storage.get('companyId'),
      status: '',
      changeIndex: 0,
      // approveFileArr: [],
      // approveFileArr:[{
      //   displayName:"aaa"
      // },{
      //   displayName:"bbb"
      // }]
      arrImgs: [],
      curIndex: 0,
      showGallary: false
    }
  },
  components: {
    CommonGallary,
    FadeAnimation
  },
  // created() {
  //   this.loadOneInnstance()
  // },
  methods: {
    doSuccess() {
      this.edit = false
      this.loadOneInnstance()
      this.showShadow = false
      this.$router.push({
        name: 'success'
      })
    },
    fileRouter(item) {
      this.$router.push({
        name: 'file',
        query: {
          url: encodeURIComponent(item.url)
        }
      })
    },
    // showFilepage(item) {
    //   let ua = window.navigator.userAgent.toLowerCase()
    //   if (ua.indexOf('micromessenger') > -1) {
    //     wx.miniProgram.navigateTo({
    //       url:
    //         '/pages/showFilePage/index?returnUrl=' +
    //         encodeURIComponent(item.url) +
    //         '&displayName=' +
    //         encodeURIComponent(item.displayName)
    //     })
    //   }
    // },
    viewImage(indexList, index) {
      this.myDataObj.businessData.prkParkLotPlateBeans[
        indexList
      ].fileList.forEach((item, i) => {
        if (
          item.postfix.indexOf('mp4') == -1 &&
          item.postfix.indexOf('flv') == -1
        ) {
          this.$set(this.arrImgs, i, item.path)
        }
      })
      this.curIndex = index
      this.showGallary = true
    },
    queryAttachmentListByOneData(item, index) {
      queryAttachmentListByOneData({
        moduleCode: 'TCP',
        target: item.id
      }).then(res => {
        // console.log("获取车辆图片")
        console.log(res)
        let carkArr = this.myDataObj.businessData.prkParkLotPlateBeans
        for (let i = 0; i < carkArr.length; i++) {
          if (carkArr[i].id == item.id) {
            this.myDataObj.businessData.prkParkLotPlateBeans[i].fileList =
              res.data
          }
        }
        this.myDataObj = JSON.parse(JSON.stringify(this.myDataObj))
        console.log(this.myDataObj)

        this.$nextTick(function() {
          let mainCard = document.querySelector('.mainCard')
          scroll = new BScroll(mainCard, {
            scrollY: true,
            click: true
          })
        })
      })
    },
    /*获取审批附件函数*/
    getApproveFileFn(target, moduleCode) {
      queryContractApproveAttachmentList({
        // target: "1399",
        // moduleCode: "1399"
        target: '1457',
        moduleCode: '1457'
      }).then(res => {
        this.approveFileArr = res.data
        /**
         * 下载单个文件
         * @param attachmentId  附件Id,附件列表里面的Id
         * @param platform      平台信息  SAAS    SaasMobile 小程序   SaasH5 H5  SaasQywx 企业微信
         * @param timestamp     时间戳  取当前时间的getTime()
         * @param sign           签名   =  32位Md5（公钥+私钥+时间戳+平台）
         */
        let time = new Date().getTime()
        for (let i = 0; i < res.data.length; i++) {
          // let obj = {
          //   platform: 'SaasH5',
          //   attachmentId: res.data[i].id,
          //   timestamp: time,
          //   sign: this.$md5('vanke2019spaceup009' + '009vanke2019spaceup001' + time + "SaasH5"),
          // }
          // res.data[i].url = 'https://rsttest.vanke.com/spaceup03/syscfg/attachmentTerminal/downLoadOneFile?data='+Encrypt.getAES(JSON.stringify(obj))
          res.data[i].url =
            serversHttp +
            '/syscfg/attachmentTerminal/downLoadOneFile?platform=SaasH5&attachmentId=' +
            res.data[i].id +
            '&timestamp=' +
            time +
            '&sign=' +
            this.$md5(
              'vanke2019spaceup009' + '009vanke2019spaceup001' + time + 'SaasH5'
            )
        }
        console.log('fujain ')
        console.log(this.approveFileArr)
        this.$nextTick(function() {
          let mainCard = document.querySelector('.mainCard')
          scroll = new BScroll(mainCard, {
            scrollY: true,
            click: true
          })
        })
      })
    },
    loadOneInnstance() {
      let timestamp = new Date().getTime()
      loadOneInnstance({
        userId: this.userInfo.userInfo.id,
        companyId: this.companyId,
        timestamp: timestamp,
        platform: 'SAAS',
        sign: this.$md5(
          'mhxzkhl990' +
            'SAAS' +
            (timestamp + Number(this.companyId)) +
            'ncbbsss123'
        ),
        instanceId: this.$route.query.id
      }).then(res => {
        console.log('审批详情')
        console.log(res.data)
        this.myDataObj = res.data
        this.myDataObj.businessData = JSON.parse(res.data.businessData)

        let carkArr = ''

        if (
          this.myDataObj.businessData.prkParkLotPlateBeans instanceof Object
        ) {
          carkArr = this.myDataObj.businessData.prkParkLotPlateBeans
            ? this.myDataObj.businessData.prkParkLotPlateBeans
            : []
        } else {
          carkArr = this.myDataObj.businessData.prkParkLotPlateBeans
            ? JSON.parse(this.myDataObj.businessData.prkParkLotPlateBeans)
            : []
        }

        this.myDataObj.businessData.prkParkLotPlateBeans = carkArr

        for (let i = 0; i < carkArr.length; i++) {
          this.queryAttachmentListByOneData(carkArr[i])
        }
        for (let i = 0; i < carkArr.length; i++) {
          this.queryAttachmentListByOneData(carkArr[i])
        }

        for (let i = 0; i < res.data.taskList.length; i++)
          if (
            res.data.taskList[i].nodeType != 1 &&
            res.data.taskList[i].nodeType != 4 &&
            res.data.currentNodeId == res.data.taskList[i].nodeId &&
            res.data.subRound == res.data.taskList[i].subRound &&
            !res.data.taskList[i].itemPassMethod &&
            res.data.taskList[i].receiverId == this.userInfo.userInfo.id &&
            (res.data.approStatus == 1000 || res.data.approStatus == 3000)
          ) {
            this.edit = true
            return
          }

        this.getApproveFileFn()
      })
    },
    /* showShadowFun(status) {
      this.showShadow = true
      this.status = status
    }, */

    /* doInstance() {
      let timestamp = new Date().getTime()
      doInstance({
        companyId: this.companyId,
        timestamp: timestamp,
        platform: 'SAAS',
        sign: this.$md5(
          'mhxzkhl990' +
            'SAAS' +
            (timestamp + Number(this.companyId)) +
            'ncbbsss123'
        ),
        instanceId: this.myDataObj.id,
        bsid: this.myDataObj.bsid,
        approvalResults: Number(this.status),
        comments: this.markContent,
        approverId: this.userInfo.userInfo.id
      }).then(res => {
        this.edit = false
        this.loadOneInnstance()
        this.showShadow = false
        this.$router.push({
          name: 'success'
        })
      })
    }, */
    /* changeTab(index) {
      this.activeTab = index
      switch (index) {
        case 0:
          scroll.scrollTo(0, 0)
          break
        case 1:
          scroll.scrollTo(0, -200)
          break
        case 2:
          let approveCard = document.querySelector('.approveCard')
          scroll.scrollToElement(approveCard)
          break
        default:
      }
    } */
  },
  // filters: {
  //   itemFilter: (value, filterArr, allSelect) => {
  //     for (let index in allSelect[filterArr])
  //       if (allSelect[filterArr][index].code == value) {
  //         return allSelect[filterArr][index].text
  //       }
  //   },
  //   timeFilter: ts => {
  //     var dd = parseInt(ts / 60 / 60 / 24, 10) //计算剩余的天数
  //     var hh = parseInt(ts / 60 / 60 % 24, 10) //计算剩余的小时数
  //     var mm = parseInt(ts / 60 % 60, 10) //计算剩余的分钟数
  //     var ss = parseInt(ts % 60, 10) //计算剩余的秒数
  //     return dd + '天' + hh + '小时' + mm + '分' + ss + '秒'
  //   },
  //   itemFeeCodeFilter: (value, feeCode) => {
  //     for (let index in feeCode)
  //       if (feeCode[index].code == value) {
  //         return feeCode[index].text
  //       }
  //   }
  // },
  // computed: {
  //   ...mapGetters(['allSelect', 'userInfo'])
  // },
  // components: {
  //   approvalProgress
  // }
}
</script>

<style lang="less" scoped>
.wrapper {
  overflow: hidden;
  display: flex;
  flex-direction: column;
  height: 100vh;

  header {
    height: 88px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 34px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.8);
    line-height: 48px;

    img {
      width: 44px;
      height: 44px;
      position: absolute;
      left: 28px;
    }
  }

  .navCard {
    height: 88px;
    display: flex;

    a {
      flex: 1;
      height: 88px;
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.6);
      line-height: 88px;
      text-align: center;
      position: relative;
    }

    .active {
      color: rgba(61, 96, 223, 1);
    }

    span {
      display: block;
      width: 40px;
      height: 6px;
      background: linear-gradient(
        270deg,
        rgba(79, 132, 255, 1) 0%,
        rgba(76, 90, 255, 1) 100%
      );
      border-radius: 4px 4px 0 0;
      position: absolute;
      bottom: 0;
      left: 106px;
    }
  }

  .mainCard {
    flex: 1;
    overflow: hidden;

    .mainBox {
      background: rgba(247, 248, 249, 1);
      padding: 20px;

      .card {
        background: rgba(255, 255, 255, 1);
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.02);
        border-radius: 16px;
        padding-bottom: 30px;
        margin-bottom: 20px;

        .cardTitle {
          height: 88px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0 30px;
          box-shadow: 0 1px 0 0 rgba(0, 0, 0, 0.09);

          h3 {
            font-size: 28px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: rgba(0, 0, 0, 0.8);
            line-height: 40px;
          }

          span {
            width: 104px;
            height: 44px;
            background: rgba(255, 246, 238, 1);
            border-radius: 22px;
            font-size: 24px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(255, 173, 93, 1);
            line-height: 44px;
            text-align: center;
          }

          a {
            font-size: 28px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.4);
            line-height: 40px;
            display: flex;

            img {
              width: 40px;
              height: 40px;
            }
          }
        }

        .appendixCard {
          display: flex;
          flex-direction: column;
          align-items: center;

          a {
            width: 670px;
            height: 100px;
            background: rgba(247, 248, 249, 1);
            border-radius: 16px;
            margin-top: 20px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 20px;
            font-size: 28px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(61, 96, 223, 1);
            line-height: 40px;
            box-sizing: border-box;

            span {
              display: flex;
              align-items: center;

              img {
                width: 40px;
                height: 40px;
              }
            }
          }
        }

        p {
          display: flex;
          margin-top: 30px;
          padding: 0 30px;

          label {
            width: 120px;
            font-size: 24px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.4);
            line-height: 34px;
            margin-right: 30px;
          }

          span {
            font-size: 24px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.8);
            line-height: 34px;
          }

          i {
            width: 40px;
            height: 40px;
            border-radius: 8px;
            font-size: 24px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            line-height: 40px;
            text-align: center;
            margin-right: 10px;
          }

          .zu {
            background: rgba(0, 0, 0, 0.02);
            border: 2px solid rgba(0, 0, 0, 0.15);
            color: rgba(0, 0, 0, 0.6);
          }

          .wu {
            opacity: 0.2;
            border: 2px solid;
            border-image: linear-gradient(
                270deg,
                rgba(79, 132, 255, 1),
                rgba(76, 90, 255, 1)
              )
              2 2;
            color: rgba(61, 96, 223, 1);
          }

          .bu {
            background: rgba(22, 188, 132, 0.1);
            border: 2px solid rgba(22, 188, 132, 0.2);
            color: rgba(22, 188, 132, 1);
          }
        }

        .box {
          display: flex;

          p {
            flex: 1;
          }
        }

        .tags_wrap {
          display: inline-block;
          position: relative;

          .tags {
            position: absolute;
            right: -80px;
            top: -3px;
            display: inline-block;
            text-align: center;
            width: 40px;
            height: 40px;
            border-radius: 8px;
            background: rgba(243, 246, 255, 1);
            border: 1px solid rgba(199, 209, 255, 1);
            font-size: 24px;
            color: rgba(61, 96, 223, 1);
            line-height: 40px;
          }
        }

        .dateCard {
          width: 670px;
          height: 120px;
          background: rgba(247, 248, 249, 1);
          border-radius: 16px;
          margin: 30px 20px 0;
          display: flex;

          .dateBox {
            flex: 1;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;

            label {
              font-size: 24px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(0, 0, 0, 0.4);
              line-height: 34px;
              margin-bottom: 6px;
            }

            span {
              font-size: 24px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(0, 0, 0, 0.8);
              line-height: 34px;
              margin-top: 6px;
            }
          }
        }

        .houseCard {
          padding: 20px;

          .houseTitle {
            width: 670px;
            height: 60px;
            background: rgba(248, 248, 248, 1);
            border-radius: 16px 0 0 16px;
            display: flex;
            align-items: center;

            span {
              font-size: 20px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(0, 0, 0, 0.6);
              line-height: 28px;
              padding-left: 20px;
            }
          }

          .houseBox {
            p {
              display: flex;
              height: 100px;
              align-items: center;
              margin: 0;
              padding: 0;

              span {
                font-size: 24px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: rgba(51, 51, 51, 1);
                line-height: 34px;
                padding-left: 20px;
              }
            }
          }

          .buildName {
            width: 256px;
          }

          .floorName {
            width: 122px;
          }

          .houseCode {
            width: 158px;
          }

          .area {
            width: 114px;
          }
        }

        .deductFromCard {
          width: 650px;
          padding: 20px 0;
          margin-left: 20px;
          overflow: hidden;

          .deductFromScroll {
            width: 900px;
          }

          .deductFromTitle {
            height: 60px;
            background: rgba(248, 248, 248, 1);
            border-radius: 16px 0 0 16px;
            display: flex;
            align-items: center;

            span {
              font-size: 20px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(0, 0, 0, 0.6);
              line-height: 28px;
              padding-left: 20px;
            }
          }

          .houseBox {
            p {
              display: flex;
              height: 100px;
              align-items: center;
              margin: 0;
              padding: 0;

              span {
                font-size: 24px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: rgba(51, 51, 51, 1);
                line-height: 34px;
                padding-left: 20px;
              }
            }
          }

          .offsetFeeCode {
            width: 120px;
          }

          .surplusMoney {
            width: 140px;
          }

          .offsetMoney {
            width: 140px;
          }

          .srcFeeCode {
            width: 100px;
          }

          .startDate {
            width: 300px;
          }
        }

        .changeCard {
          .changeTitle {
            display: flex;
            margin-top: 30px;
            margin-left: 30px;

            a {
              width: 114px;
              height: 44px;
              border-radius: 8px;
              font-size: 24px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(102, 102, 102, 1);
              line-height: 44px;
              text-align: center;
              background: rgba(0, 0, 0, 0.04);
            }

            .activeChangeTitle {
              background: linear-gradient(
                270deg,
                rgba(79, 132, 255, 1) 0%,
                rgba(76, 90, 255, 1) 100%
              );
              color: rgba(255, 255, 255, 1);
            }
          }
        }

        .cancel {
          font-size: 24px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.8);
          line-height: 34px;
        }

        .totalCostCard {
          padding: 20px;

          .totalCostTitle {
            width: 670px;
            height: 60px;
            background: rgba(248, 248, 248, 1);
            border-radius: 16px 0 0 16px;
            display: flex;
            align-items: center;

            span {
              font-size: 20px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(0, 0, 0, 0.6);
              line-height: 28px;
              padding-left: 20px;
            }
          }

          .type {
            width: 290px;
          }

          .should {
            width: 228px;
          }

          .account {
            width: 142px;
          }

          .totalCostBox {
            p {
              display: flex;
              height: 100px;
              align-items: center;
              margin: 0;
              padding: 0;

              span {
                font-size: 24px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: rgba(51, 51, 51, 1);
                line-height: 34px;
                padding-left: 20px;
              }
            }
          }

          .sumCard {
            height: 40px;
            box-shadow: 0 -1px 0 0 rgba(0, 0, 0, 0.09);
            display: flex;
            align-items: center;
            justify-content: flex-end;
            padding-top: 24px;

            h4 {
              font-size: 24px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(0, 0, 0, 0.8);
              line-height: 34px;
            }

            span {
              font-size: 28px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: rgba(0, 0, 0, 0.8);
              line-height: 40px;
            }
          }
        }

        .terminateReasons {
          padding: 30px;
          font-size: 24px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.8);
          line-height: 34px;
        }
      }
    }
  }

  footer {
    height: 112px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0 -2px 6px 0 rgba(0, 0, 0, 0.08);
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 60px;
    z-index: 999;

    a {
      &:first-child {
        width: 296px;
        height: 72px;
        border-radius: 40px;
        border: 1px solid rgba(61, 96, 223, 1);
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(61, 96, 223, 1);
        line-height: 72px;
        text-align: center;
      }

      &:last-child {
        width: 296px;
        height: 72px;
        background: linear-gradient(
          270deg,
          rgba(79, 132, 255, 1) 0%,
          rgba(76, 90, 255, 1) 100%
        );
        border-radius: 40px;
        font-size: 28px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(255, 255, 255, 1);
        line-height: 72px;
        text-align: center;
      }
    }
  }

  .shadowCard {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;

    .shadowBox {
      width: 540px;
      height: 360px;
      background: rgba(255, 255, 255, 1);
      border-radius: 16px;

      h3 {
        font-size: 32px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.8);
        line-height: 44px;
        margin: 40px 0;
        text-align: center;
      }

      textarea {
        width: 474px;
        height: 100px;
        background: rgba(0, 0, 0, 0.04);
        border-radius: 4px;
        margin-left: 32px;
        padding: 10px;
        box-sizing: border-box;
      }

      .btnCard {
        width: 540px;
        height: 96px;
        background: rgba(245, 245, 245, 1);
        border-radius: 0 0 16px 16px;
        margin-top: 40px;
        display: flex;

        a {
          flex: 1;
          font-size: 32px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: rgba(0, 0, 0, 0.8);
          line-height: 96px;
          text-align: center;
        }
      }
    }
  }

  .spanBox {
    display: block;
    display: flex;

    .spanBox_img {
      width: 160px;
      height: 160px;
      margin-right: 11px;
      border-radius: 8px;
      background: #e0e0e0;
    }
  }
}
</style>
